var map = {
	"./acessibilidade/acessibilidade.module": [
		"./src/app/admin/administracao/acessibilidade/acessibilidade.module.ts",
		"common"
	],
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"./administracao/administracao.module": [
		"./src/app/admin/administracao/administracao.module.ts",
		"common",
		"administracao.module"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"common",
		"auth.module"
	],
	"./painel/painel.module": [
		"./src/app/admin/painel/painel.module.ts",
		"common",
		"painel.module"
	],
	"./relatorios/relatorios.module": [
		"./src/app/admin/relatorios/relatorios.module.ts",
		"common",
		"relatorios.module"
	],
	"./usuarios/usuarios.module": [
		"./src/app/admin/administracao/acessibilidade/usuarios/usuarios.module.ts",
		"common",
		"usuarios.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main